<template>

  <v-app id="inspire" dark>
    <main>
      <error-modal :dialog="dialog" :error="dialogData" @close="dialog = false"></error-modal>
      <v-content class="own-flex">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12 sm10 md6 lg4 offset-sm1 offset-md3 offset-lg4 d-flex>
              <v-card light>
                <v-card-text primary-title>
                    <v-flex xs12 text-xs-center>
                      <img src="../../assets/logo.png" alt="">
                      <h3 class="headline mt-2">Entrar</h3>
                    </v-flex>
                    <v-form v-model="valid" ref="form">
                      <v-container>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field
                              light
                              class="green--text"
                              label="Correo Electronico"
                              v-model="email"
                              required
                              prepend-icon="email"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              light
                              class="green--text"
                              label="Contraseña"
                              v-model="password"
                              :type="showPwd ? 'text' : 'password'"
                              prepend-icon="lock"
                              :append-icon="showPwd ? 'visibility_off' : 'visibility'"
                              :append-icon-cb="() => showPwd = !showPwd"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 text-xs-center>
                            <v-btn
                              @click="submit"
                              color="black"
                              block
                              dark
                              round
                              class="white--text"
                              :disabled="!valid"
                            >Entrar</v-btn>
                            <a href="" class="grey--text">¿Olvidaste tu contraseña?</a>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </main>
    <v-footer app fixed>
      <span>&copy; 2017</span>
    </v-footer>
  </v-app>

</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Bus from '@/components/bus'

export default {
  name: "Login",
  data(){
    return {
      valid: false,
      email: '',
      password: '',
      showPwd: false,
      dialog: false,
      dialogData: {
        code: 500,
        title: 'Server Error',
        message: 'Error'
      }
    }
  },
  created() {
    Bus.$on(Bus.ACTION_SHOW_ALERT, event => {
      this.showDialog(event.title, event.msg)
    })
    this.checkSession()
    if(this.currentSession) {
      this.goBack()
    }
  },
  computed: {
    ...mapGetters([
      'currentSession'
    ])
  },
  methods: {
    ...mapActions([
        'login',
        'checkSession',
        'goBack'
    ]),
    showDialog(title, msg){
      this.dialogData.title = title
      this.dialogData.message = msg
      this.dialog = true
    },
    submit() {
      this.login({ email: this.email, password: this.password })
    }
  }
}
</script>

<style lang="css" scoped>
  .own-flex {
    display: flex;
  }
  .content.own-flex{
    padding: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/login.vue